// The page's global jQuery, read when application.js loads the wizards, after vendor.js. On the home
// page that is still the Sprockets copy, which carries the plugins the wizards call, so the wizards must
// not use the ProvidePlugin's copy. The key sits in a variable because the ProvidePlugin also rewrites
// `window.jQuery` and `window['jQuery']`.
const globalName = 'jQuery'

export default window[globalName]
